export default __webpack_public_path__ + "assets/right-arrow.e58c637b.svg";